var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { attrs: { id: "create-project-intro" } }, [
              _vm.isEvent
                ? _c("h1", [_vm._v("Como você quer transformar?")])
                : _c("h1", [_vm._v("O que você quer transformar?")]),
              _vm._v(" "),
              _c("form", [
                _vm.showMsg
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-danger alert-dismissible fade show",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.msg) +
                            "\n              "
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-dismiss": "alert",
                              "aria-label": "Fechar"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.hideMessage()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _vm.isEvent
                    ? _c("label", [_vm._v("Nome do seu Convite do Bem:")])
                    : _c("label", [
                        _vm._v(
                          "Nome de sua Organização Social ou título de sua campanha:"
                        )
                      ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pull-right" }, [
                    _vm._v("Máximo de 40 caractéres")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.title,
                        expression: "title"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "title",
                      placeholder: "Exemplo: Aniversário do André"
                    },
                    domProps: { value: _vm.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.title = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Taxa de conveniência de 8,90%, referente à taxa cobrada pelo meio de pagamento, sistema antifraude e manutenção desta ferramenta."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "submit" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.create()
                        }
                      }
                    },
                    [_vm._v("Continuar")]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Não se preocupe, você poderá alterar o nome depois."
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5382806", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5382806","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateProject.vue
// module id = null
// module chunks = 